import { routerReducer } from "react-router-redux";
import {
  USER_FETCH_SUCCEEDED,
  CHANGE_UNIVERSITY,
  CHANGE_QUERY,
  CHANGE_QUERY_REQUESTED,
  SEARCH_SUCCEEDED,
  SEARCH_FAILED,
  PROFESSOR_SUCCEEDED,
  NEW_COMMENT_REQUESTED,
  NEW_COMMENT_TEXT_CHANGED,
  NEW_COMMENT_SUCCEEDED,
  INAPPROPRIATE_SUCCEEDED,
  COMMENT_VOTE_SUCCEEDED,
  PROF_VOTE_SUCCEEDED
} from "./actions.js";
import { ToastsReducer } from "./containers/ToastsContainer.js";
import { SuggestionsReducer } from "./containers/SuggestionsContainer.js";

import update from "immutability-helper";

const consumeVote = function(upvote, prevVote, newVote) {
  return v => {
    if ((upvote && newVote) || (!upvote && !newVote)) {
      // if contributes to same direction.
      return v + 1;
    } else {
      // Different direction; then maybe subtract. (if swap.)
      if (prevVote !== undefined && prevVote !== newVote) {
        return v - 1;
      } else {
        return v;
      }
    }
  };
};

const ProfeCommentsReducer = function(state, action) {
  var i;
  switch (action.type) {
    case USER_FETCH_SUCCEEDED:
      return {
        ...state,
        ...action.data
      };
    case CHANGE_UNIVERSITY:
      window.history.replaceState(
        {},
        "",
        `/universities/${action.value}/search` + window.location.search
      );
      return {
        ...state,
        universityId: action.value,
        results: null,
        professor: null
      };
    case CHANGE_QUERY_REQUESTED:
      return {
        ...state,
        isLoading: true,
        results: null,
        professor: null
      };
    case CHANGE_QUERY:
      const query = action.value;
      const params = query.trim() === "" ? "" : `?q=${query}`;
      window.history.replaceState({}, "", window.location.pathname + params);
      return {
        ...state,
        query
      };
    case SEARCH_SUCCEEDED:
      return {
        ...state,
        ...action.data,
        isLoading: false
      };
    case SEARCH_FAILED:
      return {
        ...state,
        isLoading: false
      };
    case PROFESSOR_SUCCEEDED:
      return {
        ...state,
        ...action.data,
        results: null
      };
    case NEW_COMMENT_TEXT_CHANGED:
      return {
        ...state,
        newCommentText: action.value
      };
    case NEW_COMMENT_REQUESTED:
      return {
        ...state,
        newCommentText: ""
      };
    case NEW_COMMENT_SUCCEEDED:
      return {
        ...state,
        comments: state.comments.concat([action.data])
      };
    case INAPPROPRIATE_SUCCEEDED:
      i = state.comments.indexOf(action.comment);
      return update(state, { comments: { $splice: [[i, 1]] } });
    case COMMENT_VOTE_SUCCEEDED:
      i = state.comments.indexOf(action.comment);
      return update(state, {
        comments: {
          [i]: {
            upvotes: {
              $apply: consumeVote(
                true,
                state.commentVotes[action.comment.id],
                action.upvote
              )
            },
            downvotes: {
              $apply: consumeVote(
                false,
                state.commentVotes[action.comment.id],
                action.upvote
              )
            }
          }
        },
        commentVotes: { $merge: { [action.comment.id]: action.upvote } }
      });
    case PROF_VOTE_SUCCEEDED:
      return update(state, {
        professor: {
          upvotes: {
            $apply: consumeVote(
              true,
              state.professorVotes[action.professor.id],
              action.upvote
            )
          },
          downvotes: {
            $apply: consumeVote(
              false,
              state.professorVotes[action.professor.id],
              action.upvote
            )
          }
        },
        professorVotes: { $merge: { [action.professor.id]: action.upvote } }
      });
    default:
      return state;
  }
};

const initialState = {
  universityId: 1,
  query: "",

  error: null,
  results: null,
  professor: null,
  comments: null,
  newCommentText: "",

  professorVotes: null,
  commentVotes: null,
  data: {
    universities: {
      1: "UPR Rio Piedras",
      2: "Sagrado Corazón",
      3: "UPR Ponce",
      4: "UPR Mayagüez"
    },
    departments: {
      1: {
        1: "Humanidades"
      }
    }
  }
};

const reducer = function(state = initialState, action) {
  return {
    ...ProfeCommentsReducer(state, action),
    toasts: ToastsReducer(state.toasts, action),
    suggestions: SuggestionsReducer(state.suggestions, action),
    router: routerReducer
  };
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers.js